<template>
  <b-card class="text-center"
    :role="isButton ? 'button' : ''"
    :class="`text-center border-${isSelected || isHovered ? 'warning' : 'white'}`"
    @click="filter"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <b-avatar
      class="mb-1"
      variant="light-warning"
      size="45"
    >
      <feather-icon
        size="21"
        icon="XIcon"
      />
    </b-avatar>
    <div class="truncate">
      <h2 class="mb-25 font-weight-bolder">
        {{ statistic }}
      </h2>
      <span>{{ $t('pending_all') }}</span>
    </div>
  </b-card>
</template>

<script>
import { BCard, BAvatar } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BAvatar,
  },
  props: {
    statistic: {
      type: [Number, String],
      required: true,
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isHovered = ref(false)

    const filter = () => emit('filter')

    return {
      isHovered,
      filter,
    }
  },
}
</script>
